import { Spin } from "antd";
import axios from "axios";
import React, { useState } from "react";

const styles = {
  btn: {
    label: "BTN",
    colors: [
      { key: "light_grey", label: "Light Grey", other_images: ["https://upload.meeshosupplyassets.com/cataloging/1782571906625/ChatGPTImageMay26202601_32_26PM.png", "https://upload.meeshosupplyassets.com/cataloging/1782571925854/IMG20260526131210.jpg.jpeg", "https://upload.meeshosupplyassets.com/cataloging/1782571882558/ChatGPTImageMay26202602_30_51PM.png"] },
      { key: "dark_grey", label: "Dark Grey", other_images: ["https://upload.meeshosupplyassets.com/cataloging/1782572040748/ChatGPTImageJun2202602_04_42PMvx.png", "https://upload.meeshosupplyassets.com/cataloging/1782572067816/ChatGPTImageJun2202602_09_11PM.png", "https://upload.meeshosupplyassets.com/cataloging/1782571882558/ChatGPTImageMay26202602_30_51PM.png"] },
      { key: "black", label: "Black", other_images: ["https://upload.meeshosupplyassets.com/cataloging/1782572227581/ChatGPTImageMay26202603_24_56PM.png", "https://upload.meeshosupplyassets.com/cataloging/1782572166827/ChatGPTImageMay26202605_41_20PM.png", "https://upload.meeshosupplyassets.com/cataloging/1782571882558/ChatGPTImageMay26202602_30_51PM.png"] },
    ],
  },
  nara: {
    label: "Nara",
    colors: [
      { key: "light_grey", label: "Light Grey", other_images: ["https://upload.meeshosupplyassets.com/cataloging/1782575534468/ChatGPTImageJun4202602_11_37PMw.png", "https://upload.meeshosupplyassets.com/cataloging/1782575550850/ChatGPTImageMay31202603_34_38PM.png", "https://upload.meeshosupplyassets.com/cataloging/1782571882558/ChatGPTImageMay26202602_30_51PM.png"] },
      { key: "dark_grey", label: "Dark Grey", other_images: ["https://upload.meeshosupplyassets.com/cataloging/1782575468122/ChatGPTImageMay31202604_34_35PMer.png", "https://upload.meeshosupplyassets.com/cataloging/1782575492206/NewProject.png", "https://upload.meeshosupplyassets.com/cataloging/1782571882558/ChatGPTImageMay26202602_30_51PM.png"] },
      { key: "black", label: "Black", other_images: ["https://upload.meeshosupplyassets.com/cataloging/1782575319382/ChatGPTImageMay31202603_41_43PMsd.png", "https://upload.meeshosupplyassets.com/cataloging/1782575365307/ChatGPTImageMay31202603_36_30PM.png", "https://upload.meeshosupplyassets.com/cataloging/1782571882558/ChatGPTImageMay26202602_30_51PM.png"] },
    ],
  },
  lpocket: {
    label: "L-Pocket",
    colors: [
      { key: "navy_blue", label: "Navy Blue", other_images: ["https://upload.meeshosupplyassets.com/cataloging/1782575709252/ChatGPTImageMay31202605_36_29PMasd.png", "https://upload.meeshosupplyassets.com/cataloging/1782575728136/ChatGPTImageMay31202605_36_29PMfdg.png", "https://upload.meeshosupplyassets.com/cataloging/1782571882558/ChatGPTImageMay26202602_30_51PM.png"] },
      { key: "dark_grey", label: "Dark Grey", other_images: ["https://upload.meeshosupplyassets.com/cataloging/1782575789811/ChatGPTImageMay31202605_31_39PMwewe.png", "https://upload.meeshosupplyassets.com/cataloging/1782575810102/ChatGPTImageMay31202605_31_39PMytu.png", "https://upload.meeshosupplyassets.com/cataloging/1782571882558/ChatGPTImageMay26202602_30_51PM.png"] },
      { key: "black", label: "Black", other_images: ["https://upload.meeshosupplyassets.com/cataloging/1782575646952/ChatGPTImageMay31202605_38_17PMdsf.png", "https://upload.meeshosupplyassets.com/cataloging/1782575671936/ChatGPTImageMay31202605_38_17PMfg.png", "https://upload.meeshosupplyassets.com/cataloging/1782571882558/ChatGPTImageMay26202602_30_51PM.png"] },
    ],
  },
};

const colors = ["Light Gray", "Dark Grey", "Black"];

export default function PrivateListingTool() {
  const [cookies, setCookies] = useState("");
  const [selectedStyle, setSelectedStyle] = useState("");
  const [imageUrls, setImageUrls] = useState({
    btn_light_grey: ["https://i.ibb.co/K16PZ50/Chat-GPT-Image-Jun-4-2026-02-05-49-PMweee-Photoroom.png","https://i.ibb.co/XxDgXhn4/Chat-GPT-Image-Jun-29-2026-07-59-31-AMert-Photoroom.png","https://i.ibb.co/vCg6G5t5/Chat-GPT-Image-Jun-29-2026-07-59-31-AMcxv-Photoroom.png","https://i.ibb.co/TBrc4WL4/Chat-GPT-Image-Jun-29-2026-07-59-31-AMzxc-Photoroom.png","https://i.ibb.co/MxKbx95W/Chat-GPT-Image-Jun-29-2026-07-59-31-AMsdf-Photoroom.png","https://i.ibb.co/272dvgGb/Chat-GPT-Image-Jun-30-2026-08-29-26-AMgfhgg-Photoroom.png","https://i.ibb.co/FLN5yCbM/Chat-GPT-Image-Jun-30-2026-08-29-26-AMsdfds-Photoroom.png","https://i.ibb.co/1Jqkwphv/Chat-GPT-Image-Jun-30-2026-08-29-26-AMgfh-Photoroom.png","https://i.ibb.co/hRgHfYQC/Chat-GPT-Image-Jun-30-2026-08-29-26-AMfh-Photoroom.png"],
    btn_dark_grey: ["https://i.ibb.co/nMRzqrkj/Chat-GPT-Image-Jun-4-2026-02-07-54-PMjh-Photoroom.png","https://i.ibb.co/Wpfhdb79/Chat-GPT-Image-Jun-29-2026-08-00-54-AMdsf-Photoroom.png","https://i.ibb.co/0pT88CsL/Chat-GPT-Image-Jun-29-2026-08-00-54-AMgfh-Photoroom.png","https://i.ibb.co/SXthTdFR/Chat-GPT-Image-Jun-29-2026-08-00-54-AMdg-Photoroom.png","https://i.ibb.co/9m5dLMNd/Chat-GPT-Image-Jun-29-2026-08-00-54-AMasd-Photoroom.png","https://i.ibb.co/05F7JNJ/Chat-GPT-Image-Jun-30-2026-08-24-39-AMgfh-Photoroom.png","https://i.ibb.co/6RYbSs45/Chat-GPT-Image-Jun-30-2026-08-24-39-AMasd-Photoroom.png","https://i.ibb.co/HTVxCB4P/Chat-GPT-Image-Jun-30-2026-08-24-39-AMdsf-Photoroom.png","https://i.ibb.co/2Yn6pm9j/Chat-GPT-Image-Jun-30-2026-08-24-39-AMg-Photoroom.png"],
    btn_black: ["https://i.ibb.co/zWX04SHC/Chat-GPT-Image-Jun-4-2026-02-09-32-PMggg-Photoroom.png","https://i.ibb.co/8L6VDJs6/Chat-GPT-Image-Jun-29-2026-08-02-58-AMdsf-Photoroom.png","https://i.ibb.co/21wWjTJY/Chat-GPT-Image-Jun-29-2026-08-02-58-AMer-Photoroom.png","https://i.ibb.co/svSVC1TF/Chat-GPT-Image-Jun-29-2026-08-02-58-AMgfh-Photoroom.png","https://i.ibb.co/0jj0CV3K/Chat-GPT-Image-Jun-29-2026-08-02-58-AMsdf-Photoroom.png","https://i.ibb.co/LDPLMpTK/Chat-GPT-Image-Jun-30-2026-08-18-42-AMhjk-Photoroom.png","https://i.ibb.co/5WZqZb2c/Chat-GPT-Image-Jun-30-2026-08-18-42-AMhgj-Photoroom.png","https://i.ibb.co/C3651Rn0/Chat-GPT-Image-Jun-30-2026-08-18-42-AMfgh-Photoroom.png"],
    nara_light_grey: ["https://i.ibb.co/TMrDbfmN/Chat-GPT-Image-May-31-2026-03-34-55-PMewrer-Photoroom.png","https://i.ibb.co/7dgTRDXF/Chat-GPT-Image-Jun-29-2026-08-11-14-AMty-Photoroom.png","https://i.ibb.co/TB2LzN2T/Chat-GPT-Image-Jun-29-2026-08-11-14-AMsds-Photoroom.png","https://i.ibb.co/YFfT3r7Z/Chat-GPT-Image-Jun-29-2026-08-11-14-AMer-Photoroom.png","https://i.ibb.co/5gcSR9ww/Chat-GPT-Image-Jun-29-2026-08-11-14-AMrt-Photoroom.png","https://i.ibb.co/4gNyH1Tf/Chat-GPT-Image-Jun-30-2026-08-39-53-AMfdgfdg-Photoroom.png","https://i.ibb.co/p64gXm4b/Chat-GPT-Image-Jun-30-2026-08-39-53-AMasd-Photoroom.png","https://i.ibb.co/fGq6xMFS/Chat-GPT-Image-Jun-30-2026-08-39-53-AMghjg-Photoroom.png","https://i.ibb.co/3m2XxRBC/Chat-GPT-Image-Jun-30-2026-08-39-53-AMfhg-Photoroom.png"],
    nara_dark_grey: ["https://i.ibb.co/kg3qt4zn/Chat-GPT-Image-May-31-2026-04-35-51-PMasd-Photoroom.png","https://i.ibb.co/TD6fvZ4P/Chat-GPT-Image-Jun-29-2026-08-07-48-AMfdgd-Photoroom.png","https://i.ibb.co/v6M28bLG/Chat-GPT-Image-Jun-29-2026-08-07-48-AMsad-Photoroom.png","https://i.ibb.co/600dRCKw/Chat-GPT-Image-Jun-29-2026-08-07-48-AMfhg-Photoroom.png","https://i.ibb.co/0jjzMYgp/Chat-GPT-Image-Jun-29-2026-08-07-48-AMfds-Photoroom.png","https://i.ibb.co/ZzyQTVSB/Chat-GPT-Image-Jun-30-2026-08-37-14-AMgfhg-Photoroom.png","https://i.ibb.co/F4Pk21t4/Chat-GPT-Image-Jun-30-2026-08-37-14-AMfdg-Photoroom.png","https://i.ibb.co/G4r4gMqy/Chat-GPT-Image-Jun-30-2026-08-37-14-AMas-Photoroom.png","https://i.ibb.co/q30kFP5S/Chat-GPT-Image-Jun-30-2026-08-37-14-AMad-Photoroom.png"],
    nara_black: ["https://i.ibb.co/WvFX88xk/Chat-GPT-Image-May-31-2026-03-40-31-PMhj-Photoroom.png","https://i.ibb.co/GQgTd1tY/Chat-GPT-Image-Jun-29-2026-08-10-33-AMfdgfdg-Photoroom.png","https://i.ibb.co/KptQMzb4/Chat-GPT-Image-Jun-29-2026-08-10-33-AMghjg-Photoroom.png","https://i.ibb.co/sJ9dQfsm/Chat-GPT-Image-Jun-29-2026-08-10-33-AMdfg-Photoroom.png","https://i.ibb.co/JwfsBSLz/Chat-GPT-Image-Jun-29-2026-08-10-33-AMfg-Photoroom.png","https://i.ibb.co/1GycxmhN/Chat-GPT-Image-Jun-30-2026-08-32-02-AMdgds-Photoroom.png","https://i.ibb.co/XrL6xPH7/Chat-GPT-Image-Jun-30-2026-08-32-02-AMsad-Photoroom.png","https://i.ibb.co/RTkQWvNd/Chat-GPT-Image-Jun-30-2026-08-32-02-AMsd-Photoroom.png","https://i.ibb.co/fdbQH7gN/Chat-GPT-Image-Jun-30-2026-08-32-02-AMdf-Photoroom.png"],
    lpocket_navy_blue: ["https://i.ibb.co/v4C7rH33/Chat-GPT-Image-Jun-4-2026-03-31-52-PMk-Photoroom.png","https://i.ibb.co/5xFZccCB/Chat-GPT-Image-Jun-4-2026-03-31-52-PMtert-Photoroom.png","https://i.ibb.co/DDZF2nqL/Chat-GPT-Image-Jun-29-2026-08-18-40-AMrte-Photoroom.png","https://i.ibb.co/BHMxKR5b/Chat-GPT-Image-Jun-29-2026-08-18-40-AMewrwe-Photoroom.png","https://i.ibb.co/RqMXcpJ/Chat-GPT-Image-Jun-29-2026-08-18-40-AMtyu-Photoroom.png","https://i.ibb.co/DPn3wcGC/Chat-GPT-Image-Jun-30-2026-10-17-49-AM54-Photoroom.png","https://i.ibb.co/7N4JqmQ7/Chat-GPT-Image-Jun-30-2026-10-17-49-AMghfgh-Photoroom.png","https://i.ibb.co/r2PJLDc8/Chat-GPT-Image-Jun-30-2026-10-17-49-AMgh-Photoroom.png","https://i.ibb.co/1fqgzqc6/Chat-GPT-Image-Jun-30-2026-10-17-49-AMbnm-Photoroom.png"],
    lpocket_dark_grey: ["https://i.ibb.co/DPTB06Jp/Chat-GPT-Image-Jun-4-2026-03-38-06-PMfgh-Photoroom.png","https://i.ibb.co/5gvC240c/Chat-GPT-Image-Jun-29-2026-08-25-28-AMhg-Photoroom.png","https://i.ibb.co/1Jw9Ypm7/Chat-GPT-Image-Jun-29-2026-08-25-28-AMretret-Photoroom.png","https://i.ibb.co/RT57B6wt/Chat-GPT-Image-Jun-29-2026-08-25-28-AMsadfsa-Photoroom.png","https://i.ibb.co/xKtJzByn/Chat-GPT-Image-Jun-29-2026-08-25-28-AMewr-Photoroom.png","https://i.ibb.co/NgDGpj5N/Chat-GPT-Image-Jun-30-2026-10-23-00-AMdfgs-Photoroom.png","https://i.ibb.co/wFDKrjTb/Chat-GPT-Image-Jun-30-2026-10-23-00-AMgh-Photoroom.png","https://i.ibb.co/1wcC1vN/Chat-GPT-Image-Jun-30-2026-10-23-00-AMsdf-Photoroom.png","https://i.ibb.co/qFJtGVz3/Chat-GPT-Image-Jun-30-2026-10-23-00-AMfdg-Photoroom.png"],
    lpocket_black: ["https://i.ibb.co/ns4NLV4q/Chat-GPT-Image-Jun-4-2026-03-28-47-PMfd-Photoroom.png","https://i.ibb.co/WNvsGGW5/Chat-GPT-Image-Jun-4-2026-03-28-47-PMd-Photoroom.png","https://i.ibb.co/MDpKX4d6/Chat-GPT-Image-Jun-29-2026-08-16-29-AMhgf-Photoroom.png","https://i.ibb.co/4wrsQH3g/Chat-GPT-Image-Jun-29-2026-08-16-29-AMhgt-Photoroom.png","https://i.ibb.co/mFBkZ0J6/Chat-GPT-Image-Jun-29-2026-08-16-29-AMer-Photoroom.png","https://i.ibb.co/V0NbBvVw/Chat-GPT-Image-Jun-30-2026-09-50-02-AMbm-Photoroom.png","https://i.ibb.co/gMmCxshZ/Chat-GPT-Image-Jun-30-2026-09-50-02-AMvb-Photoroom.png","https://i.ibb.co/gZRSdygp/Chat-GPT-Image-Jun-30-2026-09-50-02-AMxcz-Photoroom.png","https://i.ibb.co/C5DxyxwR/Chat-GPT-Image-Jun-30-2026-09-50-02-AMsdf-Photoroom.png"]
  });

  // console.log(imageUrls)

  // const [data, setdata] = useState([])
  const [resultData, setResultData] = useState(null);

  const handleImageChange = (style, color, value) => {
    setImageUrls((prev) => ({
      ...prev,
      [`${style}_${color}`]: value,
    }));
  };

  const [loading, setloading] = useState(false)

  const getRandomImage = (images) => {
  return images[Math.floor(Math.random() * images.length)];
};


  const handleSubmit = async () => {
    setloading(true)
    try {
      const payload = {
        cookies,
        style: selectedStyle,
        images: styles[selectedStyle].colors.map((color) => ({
          color: color.label,
          imageUrl: getRandomImage(imageUrls[`${selectedStyle}_${color.key}`]) || "",
          other_images: color.other_images || []
        })),
      };



      const res = await axios.post(
        "https://reward-day-bg984.ondigitalocean.app/meesho/generateColorWiseImages",
        payload
      );

      if (res.data?.status) {
        setResultData(res.data)
        console.log(res.data);
        alert("Generated successfully");

      } else {
        alert("Generated Failed");

      }


    } catch (error) {
      console.log(error.response?.data || error.message);
      alert("API error");
    }
    setloading(false)
  };

  const finallisting = async () => {

    console.log(resultData)

    if (resultData?.imageUrl?.length == 0) {
      alert('first get img')
    }
    setloading(true)
    try {
      const payload = {
        cookies,
        images: resultData?.images,
        style: selectedStyle,


      };



      const res = await axios.post(
        "https://reward-day-bg984.ondigitalocean.app/meesho/automaticelistingmeeshoap",
        payload
      );

      if (res.data?.status) {
        setResultData(res.data)
        console.log(res.data);
        alert("Listing successfully");

      } else {
        alert("Listing Failed");

      }


    } catch (error) {
      console.log(error.response?.data || error.message);
      alert("API error");
    }
    setloading(false)
  }




  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="min-h-screen bg-slate-100 px-4 py-10">
        <div className="mx-auto max-w-5xl overflow-hidden rounded-3xl bg-white shadow-2xl">

          <div className="bg-gradient-to-r from-indigo-700 via-purple-700 to-pink-600 px-8 py-8">
            <h1 className="text-3xl font-bold text-white">
              🚀 AI Listing Creator
            </h1>
            <p className="mt-2 text-indigo-100">
              Generate optimized images, shipping charge, title and keywords
            </p>
          </div>

          <div className="p-8">
            <label className="mb-2 block text-sm font-bold text-slate-700">
              Meesho Cookies
            </label>

            <textarea
              rows={4}
              value={cookies}
              onChange={(e) => setCookies(e.target.value)}
              placeholder="Paste Meesho cookies here..."
              className="mb-8 w-full rounded-2xl border border-slate-300 bg-slate-50 p-4 text-sm outline-none focus:border-indigo-500 focus:bg-white"
            />

            <h2 className="mb-4 text-xl font-bold text-slate-900">
              Select Product Type
            </h2>

            <div className="mb-8 grid grid-cols-1 gap-4 md:grid-cols-3">
              {Object.keys(styles).map((key) => (
                <button
                  key={key}
                  onClick={() => setSelectedStyle(key)}
                  className={`rounded-2xl border p-5 text-left transition ${selectedStyle === key
                    ? "border-indigo-600 bg-indigo-600 text-white shadow-xl"
                    : "border-slate-200 bg-white hover:border-indigo-400 hover:shadow-lg"
                    }`}
                >
                  <div className="text-3xl">
                    {key === "btn" ? "👖" : key === "nara" ? "🧵" : "📦"}
                  </div>
                  <div className="mt-3 text-lg font-bold">
                    {styles[key].label}
                  </div>
                </button>
              ))}
            </div>

            {selectedStyle && (
              <div>
                <div className="mb-5 flex items-center justify-between">
                  <h2 className="text-xl font-bold text-slate-900">
                    {styles[selectedStyle].label} Images
                  </h2>

                  <span className="rounded-full bg-indigo-100 px-4 py-2 text-sm font-bold text-indigo-700">
                    {styles[selectedStyle].colors.length} Colors
                  </span>
                </div>

                <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
                  {styles[selectedStyle].colors.map((color) => (
                    <div
                      key={color.key}
                      className="rounded-2xl border border-slate-200 bg-slate-50 p-5"
                    >
                      <label className="mb-2 block font-bold text-slate-700">
                        {color.label}
                      </label>

                      <input
                        value={imageUrls[`${selectedStyle}_${color.key}`] || ""}
                        onChange={(e) =>
                          setImageUrls((prev) => ({
                            ...prev,
                            [`${selectedStyle}_${color.key}`]: e.target.value,
                          }))
                        }
                        placeholder={`Paste ${color.label} image URL`}
                        className="w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-sm outline-none focus:border-indigo-500"
                      />

                      

                       <img
                    src={imageUrls[`${selectedStyle}_${color.key}`] || ""}
                    
                    className="mx-auto h-40 w-full object-contain transition-transform duration-300 group-hover:scale-105"
                  />
                    </div>
                  ))}
                </div>

                <button
                  onClick={handleSubmit}
                  disabled={loading}
                  className={`mt-8 flex w-full items-center justify-center rounded-2xl py-4 text-lg font-bold text-white shadow-xl transition-all duration-300
  ${loading
                      ? "cursor-not-allowed bg-gray-500"
                      : "bg-gradient-to-r from-indigo-600 to-pink-600 hover:scale-[1.02] hover:shadow-2xl"
                    }`}
                >
                  {loading ? (
                    <>
                      <Spin size="small" />
                      <span className="ml-3">
                        Generating Images...
                      </span>
                    </>
                  ) : (
                    <>
                      ✨ Generate Listing
                    </>
                  )}
                </button>

                {loading && (
                  <p className="mt-4 text-center text-sm text-gray-500">
                    ⏳ Please wait... AI is generating optimized images, shipping charges,
                    titles and keywords. This may take <b>2–3 minutes.</b>
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>






      {resultData?.images?.length > 0 && (
        <div className="mt-8">
          <div className="mb-5 flex items-center justify-between">
            <div>
              <h2 className="text-2xl font-bold text-slate-900">
                Generated Listings
              </h2>
              <p className="text-sm text-slate-500">
                Optimized images, shipping charge, title and keywords
              </p>
            </div>

            <span className="rounded-full bg-indigo-50 px-4 py-2 text-sm font-semibold text-indigo-700">
              {resultData.images.length} Results
            </span>
          </div>

          <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
            {resultData.images.map((item, index) => (
              <div
                key={index}
                className="group overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
              >
                <div className="relative bg-gradient-to-br from-slate-50 via-white to-slate-100 p-5">
                  <div className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1 text-xs font-bold text-slate-700 shadow">
                    {item.color}
                  </div>

                  <div className="absolute right-4 top-4 rounded-full bg-emerald-500 px-3 py-1 text-sm font-bold text-white shadow">
                    ₹{item.charge}
                  </div>

                  <img
                    src={item.meeshourl}
                    alt={item.color}
                    className="mx-auto h-72 w-full object-contain transition-transform duration-300 group-hover:scale-105"
                  />
                </div>

                <div className="space-y-4 p-5">
                  <div className="flex items-center justify-between border-b border-slate-100 pb-3">
                    <div>
                      <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">
                        Image Size
                      </p>
                      <p className="text-sm font-bold text-slate-700">
                        {item.width} × {item.height}
                      </p>
                    </div>

                    <a
                      href={item.meeshourl}
                      target="_blank"
                      rel="noreferrer"
                      className="rounded-xl bg-slate-900 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-700"
                    >
                      Open
                    </a>
                  </div>

                  <div>
                    <div className="mb-2 flex items-center justify-between">
                      <p className="text-xs font-bold uppercase tracking-wide text-slate-500">
                        Title
                      </p>

                      <button
                        onClick={() =>
                          navigator.clipboard.writeText(item.titleData?.title || "")
                        }
                        className="rounded-lg bg-blue-50 px-3 py-1 text-xs font-bold text-blue-700 hover:bg-blue-100"
                      >
                        Copy
                      </button>
                    </div>

                    <div className="rounded-2xl border border-slate-100 bg-slate-50 p-3">
                      <p className="line-clamp-3 text-sm font-medium leading-6 text-slate-800">
                        {item.titleData?.title}
                      </p>
                    </div>
                  </div>

                  <div>
                    <div className="mb-2 flex items-center justify-between">
                      <p className="text-xs font-bold uppercase tracking-wide text-slate-500">
                        Keywords
                      </p>

                      <button
                        onClick={() =>
                          navigator.clipboard.writeText(item.titleData?.keywords || "")
                        }
                        className="rounded-lg bg-purple-50 px-3 py-1 text-xs font-bold text-purple-700 hover:bg-purple-100"
                      >
                        Copy
                      </button>
                    </div>

                    <textarea
                      readOnly
                      value={item.titleData?.keywords || ""}
                      className="h-28 w-full resize-none rounded-2xl border border-slate-100 bg-slate-50 p-3 text-sm leading-6 text-slate-700 outline-none focus:border-indigo-300"
                    />
                  </div>

                  <div className="grid grid-cols-2 gap-3 pt-2">
                    <a
                      href={item.meeshourl}
                      target="_blank"
                      rel="noreferrer"
                      className="rounded-xl border border-slate-200 py-3 text-center text-sm font-bold text-slate-700 hover:bg-slate-50"
                    >
                      View Image
                    </a>

                    <button
                      onClick={() =>
                        navigator.clipboard.writeText(item.meeshourl || "")
                      }
                      className="rounded-xl bg-indigo-600 py-3 text-sm font-bold text-white hover:bg-indigo-700"
                    >
                      Copy URL
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}



{resultData?.images?.length > 0 &&(
      <button
        onClick={finallisting}
        className="rounded-xl bg-indigo-600 p-5 text-md font-bold text-center text-white hover:bg-indigo-700"
      >
        Final Listing
      </button>
)}

    </div>
  );
}